import React, { useContext, useEffect, useState } from 'react';
import '../Default.css';
import './Mapa.css'
import { MapContainer, TileLayer, Marker, Popup, LayersControl, LayerGroup } from 'react-leaflet'
import type City from "../places/placesType"
import {
  Link
} from 'react-router-dom'
import places_file from "../places/places.json"
import { dynamicPositionStore } from './dynamicPositionStore';
import { PlayerLayer } from './PlayersLayer';
import L from 'leaflet';
import "leaflet-easybutton/src/easy-button.js";
import "leaflet-easybutton/src/easy-button.css";
import { AuthProvider } from '../globalContext';
import { HistoryLayer } from './HistoryLayer';

const cities: City[] = places_file as any;

const defaultPosition : [number, number] = [41.403823007867295, 2.1744094405567873]

function HistoryMap(props : any) {
    const {id:userId} = useContext(AuthProvider)

    // localize player
    const params = new URLSearchParams(window.location.search)
    const player = params.get("userId")

    const useParam = player && dynamicPositionStore.getPlayerCord(player)

    const playerId = useParam ? player : userId

    const startPosition = dynamicPositionStore.getPlayerCord(playerId)?.coords ?? defaultPosition


    return (
      <MapContainer center={startPosition} zoom={14} scrollWheelZoom={false} style={{width:"100vw", height:`calc(100vh - 60px)`}}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          crossOrigin={true}
        />
        <LayersControl position='topright'>

          <LayersControl.Overlay checked name='Punkty'>
            <LayerGroup>
              {cities.map((elem, city_index) => <div key={city_index}>
                {elem.places.map((entry, place_index) => 
                  <Marker position={entry.location.pos} key={`${city_index}-${place_index}`}>
                    <Popup>
                      <Link to={`/places/${city_index}/${place_index}`}> {entry.name} </Link>
                    </Popup>
                  </Marker>
                )}</div>
              )}
              </LayerGroup>
            </LayersControl.Overlay>

            <LayersControl.Overlay checked name='Historia'>
              <HistoryLayer></HistoryLayer>
            </LayersControl.Overlay>
            
          </LayersControl>
      </MapContainer>
    );

}

export default HistoryMap;